import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './theme/boostrap/custom.scss';
// import 'iview/dist/styles/iview.css';
import './theme/ivew-theme/output/iview.css';
import iView from 'iview';
import { HimuraInject } from 'himura';
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCoffee, faClock, faList, faDoorOpen, faDoorClosed, faCalendarAlt, faProjectDiagram,
  faClipboard, faWarehouse, faBed, faBath, faUserAlt, faUser, faStore, faMapSigns, faFilePowerpoint,
  faBuilding, faCertificate, faCheckCircle, faCheck, faBell,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// @ts-ignore
import locale from 'iview/dist/locale/en-US';
// @ts-ignore
import VueParticles from 'vue-particles';
// @ts-ignore
import Vue2Filters from 'vue2-filters';
// @ts-ignore
import VueHtml2Canvas from 'vue-html2canvas';
// @ts-ignore
import VueBrowserstore from 'vue-browserstore';
import { CommonConfig } from './configs/config.common';
import GlobalContextPlugin from './vue-plugin/global.context';
import VueClipboard from 'vue-clipboard2';

const VueGoogleMaps = require('vue2-google-maps');
VueClipboard.config.autoSetContainer = true;

// Init Injector
HimuraInject.Init(false);
// Get App Configurations
const config = new CommonConfig();

library.add(faCoffee, faClock, faList, faDoorOpen, faDoorClosed, faCalendarAlt, faProjectDiagram,
  faClipboard, faWarehouse, faBed, faBath, faUserAlt, faUser, faStore, faMapSigns, faFilePowerpoint,
  faBuilding, faCertificate, faCheckCircle, faCheck, faCalendarAlt, faBell);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueParticles);
Vue.use(Vue2Filters);
Vue.use(GlobalContextPlugin);
Vue.use(VueClipboard);
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleAppKey,
    libraries: 'places',
  },
});
Vue.use(VueHtml2Canvas);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(iView, { locale });
Vue.use(VueBrowserstore);
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
